import { buildingIcons } from "@/static/constants";

export const getIcon = propertyType => {
    return buildingIcons.find(icon => icon.name === propertyType)?.value ?? "defaultHouse";
};
